import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class IAPStatusTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/IAPStatusTypes`);
    }
}